import { PHONE_DISPLAY, PHONE_TEL, RERA } from "@/lib/constants";

export const Footer = () => (
  <footer className="border-t border-white/5 py-8 md:py-10 px-4 sm:px-6 md:px-10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto">
      {/* Mobile Layout (stacked) */}
      <div className="flex flex-col md:hidden items-center gap-3 text-center">
        <div>
          <div className="font-serif text-lg text-[#F8F6F0]">Palaash Paradise</div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0] mt-0.5">
            MahaRERA <span className="text-[#D4AF37] ml-1">{RERA}</span>
          </div>
        </div>
        
        <div className="text-[10px] text-[#A0A0A0] font-light max-w-[280px]">
          All images are artistic impressions from the project brochure.
        </div>
        
        <div>
          <a
            href={PHONE_TEL}
            className="text-[#D4AF37] hover:text-[#F3E5AB] transition-colors text-base tracking-wide font-medium"
            data-testid="footer-call-link"
          >
            {PHONE_DISPLAY}
          </a>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0] mt-0.5">
            Powered by Ecorb Group
          </div>
        </div>
      </div>

      {/* Desktop Layout (horizontal) */}
      <div className="hidden md:flex items-center justify-between gap-6">
        <div className="text-left">
          <div className="font-serif text-xl text-[#F8F6F0]">Palaash Paradise</div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0] mt-1">
            MahaRERA <span className="text-[#D4AF37] ml-1">{RERA}</span>
          </div>
        </div>
        
        <div className="text-center text-xs text-[#A0A0A0] font-light max-w-md">
          All images are artistic impressions from the project brochure.
        </div>
        
        <div className="text-right">
          <a
            href={PHONE_TEL}
            className="text-[#D4AF37] hover:text-[#F3E5AB] transition-colors text-sm tracking-wide"
            data-testid="footer-call-link"
          >
            {PHONE_DISPLAY}
          </a>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0A0] mt-1">
            Powered by Ecorb Group
          </div>
        </div>
      </div>
    </div>
  </footer>
);